if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    if(document.querySelector('.menus__tabs__tabs')){
        let listItems = document.querySelectorAll('.menus__tabs ul li');
        listItems.forEach((item)=>{
            let url = item.dataset.src;
            item.addEventListener('mouseenter', ()=>{
                document.querySelector('.menus__image img').classList.add('opacity');
                setTimeout(() => {
                    document.querySelector('.menus__image img').src = url;
                    document.querySelector('.menus__image img').classList.remove('opacity');
                }, 200);
            });
        })
    }


    if(document.querySelector('.tabs-quad__tabs')){
        let buttons = document.querySelectorAll('.tabs-quad__tabs li');
        let tabs = document.querySelectorAll('.tabs-quad__item');
        buttons.forEach((button)=>{
            button.addEventListener('click',(e)=>{
                let data = e.currentTarget.dataset.tab;
                buttons.forEach(function(btn){
                    btn.classList.toggle('active',btn.dataset.tab == data);
                })
                tabs.forEach(function(item){
                    item.classList.toggle('hidden',item.dataset.tab != data);
                })
            });
        });

        buttons[0].click();
    }

    if(document.querySelector('#tabs-quad-select')){
        let tabs = document.querySelectorAll('.tabs-quad__item');
        document.querySelector('#tabs-quad-select').addEventListener('change', (e)=>{
            let data = e.target.value;
            tabs.forEach(function(item){
                item.classList.toggle('hidden',item.dataset.tab != data);
            })
        });

        let val = document.querySelectorAll('#tabs-quad-select option')[0].value;
        document.querySelector('#tabs-quad-select').setAttribute('value', val);
        document.querySelector('#tabs-quad-select').dispatchEvent(new Event('change'));
    }

    // WRAP MODULE TABLES
	document.querySelectorAll('.btn:not([type="submit"])').forEach((btn) => {
		const span = document.createElement('span');
        let text = btn.innerHTML;
        btn.innerHTML = '';
        btn.appendChild(span);
        btn.querySelector('span').innerHTML = text;
	});

    // WRAP MODULE TABLES
	document.querySelectorAll('.form-module-wrapper').forEach((form) => {
        form.classList.add('wrapper','borders');
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('form-module-wrapper__container', 'animate-fade','top');
        let confirmation = form.querySelector('.form-module__confirmation');
        let contentForm = form.querySelector('.form-module');
        form.appendChild(tableWrapper);
        tableWrapper.appendChild(confirmation);
        tableWrapper.appendChild(contentForm);
	});

    $('.specials-quad__slider').slick({
        accessibility: true,
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 9000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    if(document.querySelector('.menus-full__tabs')){
        let menus = document.querySelectorAll('.menus-full__tabs li');
        let tabsMenus = document.querySelectorAll('.menus-full__menu');
        menus.forEach((button)=>{
            button.addEventListener('click',(e)=>{
                let data = e.currentTarget.dataset.menu;
                menus.forEach(function(btn){
                    btn.classList.toggle('active',btn.dataset.menu == data);
                })
                tabsMenus.forEach(function(item){
                    item.classList.toggle('hidden',item.dataset.menu != data);
                })
            });
        });
        if(window.location.hash) {
            var click_tab = window.location.hash;
            click_tab = click_tab.replace('#','');
            document.querySelector('.menus-full__tabs [data-menu="'+ click_tab +'"]').click();
        }else{
            menus[0].click();
        }
    }

    if(document.querySelector('.text-modules-wrapper')){
        document.querySelectorAll('.text-modules-wrapper').forEach((text)=>{
            text.classList.add('wrapper','borders' ,'animate-fade','top');
        })
    }

    if(document.getElementsByClassName('js-accordion-title')){        
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
    }

    if(document.querySelector('.js-open-menu')){
        document.querySelector('.js-open-menu').addEventListener('click',()=>{
            document.querySelector('.nav-mobile').classList.add('show');
        })
    }

    if(document.querySelector('.js-close-menu')){
        document.querySelector('.js-close-menu').addEventListener('click',()=>{
            document.querySelector('.nav-mobile').classList.remove('show');
        })
    }

})();